// Reference https://www.npmjs.com/package/keycode-js
const KeyCode = {
	CODE_ENTER: 13,
	CODE_SPACE: 32,
	CODE_UP: 38,
	CODE_DOWN: 40,
	CODE_LEFT: 37,
	CODE_RIGHT: 39,
	CODE_ESCAPE: 27,
	CODE_DELETE: 46,
	CODE_TAB: 9,
	CODE_END: 35,
	CODE_HOME: 36,
	CODE_BACK_SPACE: 8,
};

const Code = {
	CODE_ENTER: "Enter",
	CODE_SPACE: "Space",
	CODE_UP: "ArrowUp",
	CODE_DOWN: "ArrowDown",
	CODE_LEFT: "ArrowLeft",
	CODE_RIGHT: "ArrowRight",
	CODE_ESCAPE: "Escape",
	CODE_DELETE: "Delete",
	CODE_TAB: "Tab",
	CODE_END: "End",
	CODE_HOME: "Home",
	CODE_BACK_SPACE: "Backspace",
};
export default KeyCode;
export { KeyCode, Code };
